import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-3 row pt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = {
  for: "fromDate",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_5 = { class: "col-sm-8" }
const _hoisted_6 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_7 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_8 = { class: "row mt-2" }
const _hoisted_9 = {
  for: "toDate",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_10 = { class: "col-sm-8" }
const _hoisted_11 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_12 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_13 = { class: "row mt-2" }
const _hoisted_14 = {
  for: "fieldId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_15 = { class: "row mt-2" }
const _hoisted_16 = {
  for: "mappingInvoiceId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_17 = { class: "col-sm-8" }
const _hoisted_18 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_19 = { class: "row mt-2" }
const _hoisted_20 = {
  for: "mappingProviderId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_21 = { class: "col-sm-8" }
const _hoisted_22 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_23 = { class: "row mt-2" }
const _hoisted_24 = {
  for: "mappingStatus",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_25 = { class: "col-sm-8" }
const _hoisted_26 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_27 = { class: "row mt-2" }
const _hoisted_28 = {
  for: "mappingStatusCompleted",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_29 = { class: "col-sm-8" }
const _hoisted_30 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_31 = { class: "row mt-2" }
const _hoisted_32 = {
  for: "mappingFiatSum",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_33 = { class: "col-sm-8" }
const _hoisted_34 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_35 = { class: "row mt-2" }
const _hoisted_36 = {
  for: "mappingRewardPercent",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_37 = { class: "col-sm-8" }
const _hoisted_38 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_39 = { class: "row mt-2" }
const _hoisted_40 = {
  for: "mappingRate",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_41 = { class: "col-sm-8" }
const _hoisted_42 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_43 = { class: "row mt-2" }
const _hoisted_44 = {
  for: "mappingRowNum",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_45 = { class: "col-sm-8" }
const _hoisted_46 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_47 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_48 = { class: "col-sm-12" }
const _hoisted_49 = { class: "p-0 m-0" }
const _hoisted_50 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_51 = { class: "col-sm-12" }
const _hoisted_52 = { class: "me-2" }
const _hoisted_53 = { class: "row mt-2" }
const _hoisted_54 = { class: "col-sm-12" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_57 = { class: "col-sm-12" }
const _hoisted_58 = {
  key: 0,
  class: "col-sm-12"
}
const _hoisted_59 = {
  key: 1,
  class: "col-sm-12"
}
const _hoisted_60 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.$t('labels.provider_upload_report'),
    "dialog-class": "modal-lg",
    modelValue: _ctx.provider !== null,
    "footer-class": "d-flex justify-content-end",
    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ($event === false && (_ctx.provider = null)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        class: "h-100"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("labels.from_date")), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_DatePicker, {
                      modelValue: _ctx.filters.fromDate,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.fromDate) = $event)),
                      mode: "dateTime",
                      "model-modifiers": {string: true},
                      is24hr: "",
                      masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                    }, {
                      default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                        _createElementVNode("input", {
                          class: "form-control form-control-sm",
                          placeholder: _ctx.$t('labels.from_date'),
                          value: inputValue,
                          onFocus: togglePopover,
                          onChange: inputEvents.change
                        }, null, 40, _hoisted_7)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("labels.to_date")), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_DatePicker, {
                      modelValue: _ctx.filters.toDate,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.toDate) = $event)),
                      mode: "dateTime",
                      "model-modifiers": {string: true},
                      is24hr: "",
                      masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                    }, {
                      default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                        _createElementVNode("input", {
                          class: "form-control form-control-sm",
                          placeholder: _ctx.$t('labels.to_date'),
                          value: inputValue,
                          onFocus: togglePopover,
                          onChange: inputEvents.change
                        }, null, 40, _hoisted_12)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("labels.columns_mapping")) + ":", 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("labels.our_id")), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.mappingInvoiceId) = $event)),
                      type: "text",
                      class: "form-control",
                      placeholder: "A",
                      id: "mappingInvoiceId"
                    }, null, 512), [
                      [_vModelText, _ctx.filters.mappingInvoiceId]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("labels.provider_id")), 1),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.mappingProviderId) = $event)),
                      type: "text",
                      class: "form-control",
                      placeholder: "B",
                      id: "mappingProviderId"
                    }, null, 512), [
                      [_vModelText, _ctx.filters.mappingProviderId]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("labels.status")), 1),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.mappingStatus) = $event)),
                      type: "text",
                      class: "form-control",
                      placeholder: "C",
                      id: "mappingStatus"
                    }, null, 512), [
                      [_vModelText, _ctx.filters.mappingStatus]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("labels.completed_status")), 1),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.mappingStatusCompleted) = $event)),
                      type: "text",
                      class: "form-control",
                      placeholder: "completed",
                      id: "mappingStatusCompleted"
                    }, null, 512), [
                      [_vModelText, _ctx.filters.mappingStatusCompleted]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("labels.fiat_sum")), 1),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.mappingFiatSum) = $event)),
                      type: "text",
                      class: "form-control",
                      placeholder: "D",
                      id: "mappingFiatSum"
                    }, null, 512), [
                      [_vModelText, _ctx.filters.mappingFiatSum]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("labels.reward_rate")), 1),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.mappingRewardPercent) = $event)),
                      type: "text",
                      class: "form-control",
                      placeholder: "E",
                      id: "mappingRewardPercent"
                    }, null, 512), [
                      [_vModelText, _ctx.filters.mappingRewardPercent]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t("labels.rate")), 1),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.mappingRate) = $event)),
                      type: "text",
                      class: "form-control",
                      placeholder: "F",
                      id: "mappingRate"
                    }, null, 512), [
                      [_vModelText, _ctx.filters.mappingRate]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("labels.row_number")), 1),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.mappingRowNum) = $event)),
                      type: "text",
                      class: "form-control",
                      id: "mappingRowNum"
                    }, null, 512), [
                      [_vModelText, _ctx.filters.mappingRowNum]
                    ])
                  ])
                ])
              ]),
              (!_ctx.fileAttachment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _mergeProps({ style: {"cursor":"pointer","border":"1px dashed"} }, _ctx.dropzone.getRootProps(), { class: "payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center" }), [
                        _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.dropzone.getInputProps())), null, 16),
                        _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.helper.trans('labels.payout_upload_files')), 1)
                      ], 16)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.fileAttachment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)),
                      _cache[16] || (_cache[16] = _createTextVNode()),
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.fileAttachment?.file.name), 1),
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.removeFile()), ["prevent"]))
                      }, _cache[14] || (_cache[14] = [
                        _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                      ]))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("button", {
                    onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.uploadForm()), ["prevent"])),
                    disabled: !_ctx.fileAttachment,
                    class: "btn w-100 btn-outline-success"
                  }, _toDisplayString(_ctx.$t('labels.check_report')), 9, _hoisted_55)
                ])
              ]),
              (_ctx.checkResult)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t('labels.check_report_diff_count')) + " " + _toDisplayString(_ctx.checkResult.diffCount), 1),
                    (_ctx.checkResult.diffSum)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.$t('labels.check_report_diff_sum')) + " " + _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.checkResult.diffSum)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.checkResult.diffAttachment)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                          _createElementVNode("a", {
                            href: `${_ctx.api.baseUrl()}/attachments/${_ctx.checkResult.diffAttachment}`,
                            target: "_blank"
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('labels.download_report')) + " ", 1),
                            _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1))
                          ], 8, _hoisted_60)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.provider = null), ["prevent"])),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}